module.exports = __webpack_public_path__ + "img/profile-promo.781d5c44.svg";